import React from "react"
import PropTypes from "prop-types"
import { StyledField } from "./styles"
import { useMask } from "@react-input/mask"

const PlainDateField = ({ handleInputChange, ...rest }) => {
  const date_format = navigator.language === "en-US" ? "MM/DD/YYYY" : "DD/MM/YYYY"
  const { name } = rest

  const dateMask = useMask({
    mask: date_format,
    replacement: { D: /\d/, M: /\d/, Y: /\d/ },
    showMask: true,
    separate: true
  })

  const onChange = (value) => {
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  return (
    <StyledField
      ref={dateMask}
      type="text"
      onChange={(input) => onChange(input.target.value)}
      {...rest}
      placeholder={date_format}
      pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}"
      value={rest.value}
    />
  )
}

PlainDateField.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string
}

PlainDateField.defaultProps = {
  handleInputChange: undefined,
  placeholder: "DD/MM/YYYY"
}

export default PlainDateField
